import {FC} from "react";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";
import {LearnModule} from "../../../../lib/src/api/repositories/learn-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";


export const BulkDeleteLearnModuleModal: FC<{ selected: string[], modules: LearnModule[], reload: () => void }> = (props) => {
  const { learn } = useApiCall(config)
  const archive = async () => {
    const promises = props.selected.map(async (module) => {
      const matchedModule = props.modules.find(m => m.id === module)
      if (matchedModule !== undefined) {
        await learn.archiveModule(matchedModule)
      }
    })
    await Promise.all(promises)
    props.reload()
  }

  return <>
    <div>Je staat op het punt om {props.selected.length} modules te verwijderen. Doorgaan?</div>
    <ModalFooter text={'Verwijder'} onSubmit={archive} />
  </>
}